export const absolute = {
  y: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
  },
};
